var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-image.j2"] = require( "macros/product-image.j2" );
dependencies["macros/product-video.j2"] = require( "macros/product-video.j2" );
dependencies["product-video/icon-play-link.j2"] = require( "product-video/icon-play-link.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/carousel-slider/slider-slides.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-image.j2", false, "product/templates/carousel-slider/slider-slides.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("productImage")) {
var t_4 = t_1.productImage;
} else {
cb(new Error("cannot import 'productImage'")); return;
}
context.setVariable("productImage", t_4);
output += "\n";
env.getTemplate("macros/product-video.j2", false, "product/templates/carousel-slider/slider-slides.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("productVideo")) {
var t_8 = t_5.productVideo;
} else {
cb(new Error("cannot import 'productVideo'")); return;
}
context.setVariable("productVideo", t_8);
output += "\n\n\n";
output += "\n\n<div class=\"o-slider-thumbnails__inner\">\n\n    ";
var t_9;
t_9 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "primarySlice")),"sliceHashToIndex")),"code")),runtime.contextOrFrameLookup(context, frame, "colorCode"));
frame.set("sliceIndex", t_9, true);
if(frame.topLevel) {
context.setVariable("sliceIndex", t_9);
}
if(frame.topLevel) {
context.addExport("sliceIndex", t_9);
}
output += "\n    ";
var t_10;
t_10 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "primarySlice")),"sliceItems")),runtime.contextOrFrameLookup(context, frame, "sliceIndex"));
frame.set("sliceItem", t_10, true);
if(frame.topLevel) {
context.setVariable("sliceItem", t_10);
}
if(frame.topLevel) {
context.addExport("sliceItem", t_10);
}
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "sliceItem")) {
output += "\n\n        ";
frame = frame.push();
var t_13 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "sliceItem")),"carouselCodes");
if(t_13) {var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("carouselCode", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += "\n\n            <div data-image-viewcode=\"";
output += runtime.suppressValue(t_14, env.opts.autoescape);
output += "\" data-thumb-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" class=\"o-slider-thumbnails__slide js-slider__slide o-slider-thumbnails__slide--product-image ";
if(t_14 == "vid") {
output += " c-product-video-thumbnail ";
;
}
output += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") > 0) {
output += "o-carousel--hidden";
;
}
output += "\">\n\n                ";
if(t_14 == "vid") {
output += "\n\n                    <div class=\"c-product-video-thumbnail__wrapper c-product-video-thumbnail__wrapper--hidden\">\n\n                        <a class=\"c-product-video-thumbnail__a\">\n\n                            ";
env.getTemplate("product-video/icon-play-link.j2", false, "product/templates/carousel-slider/slider-slides.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
output += t_16
output += "\n\n                        </a>\n\n                    </div>\n\n                ";
})});
}
var t_19;
t_19 = "slider-thumbnail__slide-inner-" + "" + ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen")?"-qs":"")) + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index");
frame.set("thumbId", t_19, true);
if(frame.topLevel) {
context.setVariable("thumbId", t_19);
}
if(frame.topLevel) {
context.addExport("thumbId", t_19);
}
output += "<a href=\"#\" tabindex=\"0\" class=\"o-slider-thumbnails__slide-inner\" id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "thumbId"), env.opts.autoescape);
output += "\" aria-hidden=\"true\">\n\n                    ";
var t_20;
t_20 = (lineno = 50, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["pdp_carousel_thumbnail_alt"])) + "" + " " + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") + "" + ": " + "" + runtime.contextOrFrameLookup(context, frame, "altText");
frame.set("slideAltText", t_20, true);
if(frame.topLevel) {
context.setVariable("slideAltText", t_20);
}
if(frame.topLevel) {
context.addExport("slideAltText", t_20);
}
output += "\n\n                    ";
output += runtime.suppressValue((lineno = 53, colno = 36, runtime.callWrap(t_4, "productImage", context, [runtime.contextOrFrameLookup(context, frame, "baseImageUrl"),runtime.contextOrFrameLookup(context, frame, "imageStyle"),runtime.contextOrFrameLookup(context, frame, "colorCode"),t_14,runtime.makeKeywordArgs({"preset": runtime.contextOrFrameLookup(context, frame, "preset"),"imageHeight": 150,"altText": runtime.contextOrFrameLookup(context, frame, "slideAltText"),"class": "o-slider-thumbnails--product-image","disableZoom": true,"quality": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality")})])), env.opts.autoescape);
output += "\n\n                </a>\n\n            </div>\n\n        ";
;
}
}
frame = frame.pop();
output += "\n\n    ";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/carousel-slider/slider-slides.j2"] , dependencies)